module.exports = __webpack_public_path__ + "img/arrow.download.c85b80ed.svg";